
export class Meses{
    id_mes : number;
    numero_mes : number;
    nombre_mes : string;
}

export class TiposCE{
    id:number;
    tipoComprobante: string;
    nombreComprobante: string;
}

export class Empresa{
    id_empresa: string;
    Empresa : string;
}

export class Areas{
    id_area= Number;    // id_area
    Area: string;       // nombre_area
    Empresa: number;
}

export class Dependencia {
    id_dependencia: string;
    nombre_dependencia: string;
}

export class Subdependencia{
    id_subdependencia: number;
    nombre_subdependencia : string;
}



export class Usuario {
    id_usuario: string;
    nombre_completo: string;
}

export class Puc{
    id : Number;
    codigo: string;
    cuenta : string;
    nivel : string;
    idEmpresa : number;
    estado: number;
}

export class ComprobanteE{
    idComprobante: number;
    numComprobante: number;
    monto: number;
    empresa : number;
    tipoComprobante: number;
    estado?: number;
    mes: number;
    anio:number;
}

export class Bitacora{
    id_gasto: number;   // se autogenera
    valor:number;           // obligatorio
    fecha:string;     // campo obligatorio 
    tipo?:number;     // campo obligatorio      
    id_empresa?:number;   // campo obligatorio
    id_area?:number;    
    id_dependencia?:number;
    id_subdependencia?:number;
    id_puc?:number; 
    id_usuario?:number;    
    nombre_empresa?:string;   
    concepto?:string;   // obligatorio
    mes:number;
    anio:number;
    estado:number;
    comprobante:number;
    numComprobante: string;
    tipoGasto: string;
}

export class Query{
    fieldCount: Number
    affectedRows: Number
    insertId: Number
    serverStatus: Number
    warningCount: Number
    message: String
    protocol41: Boolean
    changedRows: Number
}
